// Cart quantity update
document.addEventListener('DOMContentLoaded', function() {
  const quantityInputs = document.querySelectorAll('.cart-quantity-input');
  
  quantityInputs.forEach(input => {
    input.addEventListener('change', function() {
      document.querySelector('form[action="/cart"]').submit();
    });
  });
  
  // Remove item functionality
  const removeLinks = document.querySelectorAll('.cart-item-remove');
  
  removeLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const itemKey = this.closest('.cart-item-card').querySelector('input[name="updates[]"]').id.replace('updates_', '');
      
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      })
      .then(response => response.json())
      .then(data => {
        window.location.reload();
      });
    });
  });
});